import {infiniteQueryOptions, keepPreviousData} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {UserProductsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListProductsQueryDependencies = Pick<UserProductsDependencies, 'controllers'>;

export const listProductsQuery = ({controllers}: ListProductsQueryDependencies, q = '') =>
  infiniteQueryOptions({
    queryKey: [...keys.list(), q] as const,
    queryFn: ({pageParam}) =>
      controllers.productController.list({cursor: pageParam, q}).then(unwrap),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    placeholderData: keepPreviousData,
  });
